export enum StudyCourse {
    Course1 = 1,
    Course2 = 2,
    Course3 = 3,
    Course4 = 4,
    Course5 = 5,
    Course6 = 6,
}
